import { clsx } from 'clsx';
import styles from './WizardHeaderStepProgress.module.scss';
import { wizardHeaderStepProgressDataIds } from './data-ids';

export interface WizardHeaderStepProgressProps {
  active: boolean;
  completed: boolean;
  stepCount: number;
}

export function WizardHeaderStepProgress({
  stepCount,
  active,
  completed
}: WizardHeaderStepProgressProps) {
  return (
    <div
      data-id={wizardHeaderStepProgressDataIds.container}
      className={clsx(
        styles.wizardHeaderStepProgress,
        active && styles.active,
        completed && styles.completed,
        'center-flex-row justify-center wizard-header-step-progress'
      )}
    >
      {active ? (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='11'
          height='10'
          viewBox='0 0 11 10'
          fill='none'
          data-id={wizardHeaderStepProgressDataIds.active}
        >
          <circle cx='5.5' cy='5' r='5' fill='#4983E0' />
        </svg>
      ) : null}

      {!completed && !active ? (
        <span
          data-id={wizardHeaderStepProgressDataIds.stepNumber}
          className={clsx('text-default text-medium', styles.stepNo)}
        >
          {stepCount}
        </span>
      ) : null}

      {completed ? (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='11'
          height='8'
          viewBox='0 0 11 8'
          fill='none'
          data-id={wizardHeaderStepProgressDataIds.completed}
        >
          <path
            d='M1.64237 4.56629C1.47151 4.39544 1.1945 4.39544 1.02365 4.56629C0.852794 4.73715 0.852794 5.01416 1.02365 5.18501L3.64865 7.81001C3.8195 7.98087 4.09651 7.98087 4.26737 7.81001L10.684 1.39334C10.8549 1.22249 10.8549 0.94548 10.684 0.774625C10.5132 0.603771 10.2362 0.603771 10.0653 0.774625L3.95801 6.88193L1.64237 4.56629Z'
            fill='white'
          />
        </svg>
      ) : null}
    </div>
  );
}
